/**
 * The number of conversations with a rider message Customer Support has not
 * read, for the Support Chat item of the sidebar (the same Badge the other
 * items use). Read from ant every minute through React Query; while the
 * Support Chat page is open it writes its live count into the same query,
 * so the badge follows the socket there instead of waiting for a poll.
 */

import { useQuery } from '@tanstack/react-query';
import { fetchUnreadSummary, UnreadSummaryRow } from './api';
import { isAfter, mapSenderType } from './mappers';

export const SUPPORT_CHAT_UNREAD_KEY = ['supportChatUnread'] as const;

const REFRESH_MS = 60000;

/** Rows whose newest message is the rider's and came after CS last read. */
export function countUnread(rows: UnreadSummaryRow[]): number {
  return rows.filter((row) => {
    const last = row.messages?.[0];
    if (!last || mapSenderType(last.senderType, last.visibility) !== 'user') return false;
    return isAfter(last.insertedAt, row.conversation?.lastReadAtAdmin);
  }).length;
}

export async function fetchUnreadConversationCount(): Promise<number> {
  return countUnread(await fetchUnreadSummary());
}

export function useSupportChatUnread(enabled: boolean) {
  return useQuery({
    queryKey: SUPPORT_CHAT_UNREAD_KEY,
    queryFn: fetchUnreadConversationCount,
    enabled,
    refetchInterval: REFRESH_MS,
    refetchIntervalInBackground: false,
    staleTime: REFRESH_MS / 2,
    retry: false,
  });
}
